import React from "react";
import {
    Dialog,
    DialogContent,
    Box,
    Typography,
    styled
} from "@mui/material";
import { PrimaryFormLoadingActionButton } from "../../../Features/Table/GenericDraggableTable/TableStyles";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseButton from "../../../Components/CloseButton";

const StyledDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 8,
        boxShadow: theme.shadows[5],
        width: "490px",
        maxWidth: "90%",
        padding: '24px'
    },
}));

const UploadStatusModal = ({ open, onClose, uploadedRecordsCount }) => {
    return (
        <StyledDialog open={open} onClose={() => {}}>
            <DialogContent sx={{ p: 0 }}>
                {/* Close Button */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <CloseButton onClick={onClose} />
                </Box>

                {/* Header with Title and Close Button */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2.5, mt: -2 }}>
                    <Typography variant="fw600s16c000000" sx={{ fontSize: '18px', lineHeight: '18px' }}>
                        Upload Status
                    </Typography>
                </Box>

                {/* Success Message Card */}
                <Box
                    sx={{
                        backgroundColor: '#EDF9F4',
                        borderRadius: '12px',
                        py: 3.5,
                        px: 3,
                        mb: 2.5,
                        textAlign: 'center'
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, mb: 2.5 }}>
                        <CheckCircleIcon sx={{ color: '#196D00', fontSize: '24px' }} />
                        <Typography
                            variant="fw600s16c000000"
                            sx={{
                                color: '#196D00',
                                fontSize: '18px',
                                lineHeight: '18px'
                            }}
                        >
                            Successful Upload
                        </Typography>
                    </Box>
                    <Typography
                        variant="fw400s14c000000"
                        sx={{
                            lineHeight: '22px'
                        }}
                    >
                        {uploadedRecordsCount} records have been uploaded. Changes will reflect in Your Inventory.
                    </Typography>
                </Box>

                {/* View Summary Button */}
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <PrimaryFormLoadingActionButton
                        onClick={onClose}
                        loading={false}
                        sx={{
                            borderRadius: '12px',
                            px: 3,
                            py: 1,
                        }}
                    >
                        <Typography variant="fw600s14c000000" sx={{lineHeight: '22px', color: '#FFFFFF'}}>View Summary</Typography>
                    </PrimaryFormLoadingActionButton>
                </Box>
            </DialogContent>
        </StyledDialog>
    );
};

export default UploadStatusModal;
